import { useMemo } from 'react';

import * as styles from '@/styles/components/Spinner';

type Spinner = {
  size: 'sm' | 'md' | 'lg';
};

const Spinner = ({ size = 'md' }: Spinner) => {
  // width/height と border-width
  const style = useMemo(() => {
    switch (size) {
      case 'sm':
        return ['2.1rem', '0.2rem'];
      case 'lg':
        return ['5.7rem', '0.6rem'];
      default:
        return ['3.6rem', '0.4rem'];
    }
  }, [size]);

  return <div css={styles.root(style)} aria-label='処理中' />;
};

export default Spinner;
